import service from '@/services/SIRgpd_inf_cont';

export default {
  namespaced: true,

  actions: {
    /**
     * Permite obtener los parámetros de un WebApp Vue.
     */
    read({ dispatch, rootGetters }) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRgpd_inf_cont: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRgpd_inf_cont: [
              {
                picdoc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
              },
            ],
            eefeature: [
              {
                piope: '',
                picam: '',
                piregini: 1,
                pinumreg: 15,
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.dsSIRgpd_inf_cont;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              resolve(data.eegpd_inf_cont[0]);
            } else if (data?.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: error?.message || null,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
